import {mockups} from "../mockups";

export function initPaymentStatusPage(){

    if(!$('#payment_page_landing').length){
        return;
    }

    const AJAX_MODE = 'test';
    const AJAX_URL = AJAX_MODE === 'dev' ? '' : '/ajax/checkPayment/';

    const $preloader = $('#fullscreen_preloader');
    const $paymentModal = $('#payment_status_modal');

    let sendPaymentRequestsCount = 0;

    init();

    function init(){
        showPreloader();

        const getParameters = window.location.search;
        const isGetParametersCorrect = getParameters.includes('orderId');
        let orderId = '';

        //получаем из гет параметра id заказа
        if (isGetParametersCorrect) {
            orderId = window.location.search.split('&').find(getParameter => {
                return getParameter.includes('orderId');
            }).split('=')[1];
            sendPaymentStatus(orderId);

        }else{
            errorHandler();
        }


        function sendPaymentStatus(orderId) {
            const data = {
                paymentRegNum: orderId,
            }

            $.ajax({
                url: `${AJAX_URL}`,
                type: 'POST',
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(data),
                xhrFields: {
                    withCredentials: true
                },
                success: function (data) {
                    isDataValid(data);
                },
                error: function (data) {
                    if (AJAX_MODE === 'dev') {
                        data = mockups.sendPaymentStatus;
                        isDataValid(data);

                    } else {
                        errorFn();
                    }
                },
                timeout: 30000
            });

            function isDataValid(data) {
                if (
                    data
                    && data?.status === 'success'
                ) {
                    successFn();

                } else if (data?.status === 'wait' || !data) {
                    errorFn(data);

                } else if (data?.status === 'error' || !data) {
                    errorHandler();
                }
            }

            function successFn() {
                $paymentModal.find('.success').css('display', 'flex');
                showPaymentModal();
            }

            // повторяем запрос через 5 секунд в случае, если запрос не выполнился/ ошибка на сервере или сбере и статус оплаты не известен
            // 5 запросов максимум
            function errorFn() {
                sendPaymentRequestsCount++;

                if(sendPaymentRequestsCount === 6){
                    errorHandler();
                    return;
                }

                setTimeout(() => {
                    sendPaymentStatus(orderId);
                }, 5000);
            }
        }

        function errorHandler(){
            $paymentModal.find('.error').css('display', 'flex');
            showPaymentModal();
        }
    }

    function showPreloader(){
        $preloader.css('display', 'flex');
    }

    function hidePreloader(){
        $preloader.css('display', 'none');
    }

    function showPaymentModal(){
        $paymentModal.addClass('fade-in-show');
    }

    function hideModal($modalClose){
        $paymentModal.removeClass('fade-in-show');
        $paymentModal.find('.success').css('display', 'none');
        $paymentModal.find('.error').css('display', 'none');
    }
}